import { render, staticRenderFns } from "./AboutHippoArt.vue?vue&type=template&id=6eacc1b9&scoped=true"
import script from "./AboutHippoArt.vue?vue&type=script&lang=js"
export * from "./AboutHippoArt.vue?vue&type=script&lang=js"
import style0 from "./AboutHippoArt.vue?vue&type=style&index=0&id=6eacc1b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eacc1b9",
  null
  
)

export default component.exports